import { useNode } from "@craftjs/core";
import React, { useCallback } from "react";
import { CountUpSettings } from "./settings";
import GrigoraCSSRenderer from "./../css-render";
import Count from "react-countup";
import icon from "./icon";
import { CMSCountUpSettings } from "./cms-settings";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import CMSIcon from "./cms-icon";

export const CountUp = (props) => {
  const {
    id,
    connectors: { connect, drag },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    countStart = 0,
    countEnd = 100,
    countTime = 3,
    numFormat,
    numPrefix = "",
    numSuffix = "",
    numTSeparator,
  } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-count-up": true,
      [`count-up-${id}`]: id,
    },
    blockProps.className,
  );

  const formatCurrency = (value) =>
    new Intl.NumberFormat("en", {
      notation: "compact",
    }).format(value);

  const handleFormatCurrency = useCallback(
    (countEnd) => `${numPrefix}${formatCurrency(countEnd)}${numSuffix}`,
    [countEnd, numPrefix, numSuffix],
  );

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>
        {`${GrigoraCSSRenderer.blockCSS__CountUp(id, props)}
  `}
      </style>
      <span>
        <Count
          start={countStart}
          end={countEnd}
          duration={countTime}
          prefix={numPrefix}
          suffix={numSuffix}
          separator={numTSeparator}
          formattingFn={numFormat ? handleFormatCurrency : undefined}
        />
      </span>
    </div>
  );
};

// To Avoid Mangling in Production
CountUp.displayName = "CountUp";

CountUp.craft = {
  name: "Count Up",
  props: {},
  related: {
    CMSsettings: CMSCountUpSettings,
    supports: [
      "grigora/directory-conditional",
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    settings: CountUpSettings,
    icon: icon,
    CMSIcon: CMSIcon,
    keywords: ["Count Up", "Number", "Counter"],
  },
  custom: {
    name: "Count Up",
    slug: "grigora/count-up",
  },
};
